
import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';

export const PrevArrow = (props) => {
    const { className, onClick } = props;
    return(
      <div onClick={onClick} className={`arrow ${className}`} >
        <AiOutlineArrowLeft class="arrows" style={{color:"white"}}/>
      </div>
    )
}

export const NextArrow = (props) => {
    const { className, onClick } = props;
    return(
      <div onClick={onClick} className={`arrow ${className}`} >
        <AiOutlineArrowRight class="arrows" style={{color:"white"}}/>
      </div>
    )
}